// Pulled these palettes from other repos that use the header
const basePalette = {
  pageContainerBackgroundColor: '#e2e2e2',
  pageContainerBorderColor: '#ececec',
  headerMastheadBackgroundColor: '#002D72',
  headerMastheadTextColor: '#ffffff',
  headerNavigationBackgroundColor: '#041E42',
  headerNavigationBorderColor: '#057AFF',
  headerNavigationTextColorHover: '#ffffff',
  headerNavigationTextColor: '#ffffff',
  footerTitleColor: '#fff',
  footerTextColor: '#d2d2d2',
  footerBackgroundColor: '#333',
  footerBorderColor: '#e2e2e2',
  footerLinkColor: '#ffffff',
  footerLinkColorHover: '#147CD1',
  footerLinkColorActive: '#fff',
  buttonPrimaryBackgroundColor: '#4c8cee',
  buttonPrimaryBackgroundColorHover: '#246ad8',
  buttonPrimaryTextColor: '#ffffff',
  buttonPrimaryTextColorHover: '#ffffff',
  buttonSpotlightBackgroundColor: '#333333',
  buttonSpotlightBackgroundColorHover: 'lighten',
  buttonSpotlightTextColor: '#ffffff',
  buttonSpotlightTextColorHover: '#ffffff',
  tableHeaderBackgroundColor: '#002D72',
  tableRowBackgroundColor: '#ffffff',
  tableTextColor: '#333333',
  organismSectionTitleColor: '#333333',
  organismTitleColor: '#333333',
  organismTextColor: '#333333',
  organismTagBackgroundColor: '#002D72',
  organismTagTextColor: '#ffffff',
  organismBackgroundColor: '#ffffff',
  organismBorderColor: '#ececec',
  organismLinkColor: '#333333',
  organismLinkColorHover: '#147CD1',
  organismLinkTextDecoration: 'none',
  organismLinkColorActive: '#002D72',
  organismScrimTitleColor: '#ffffff',
  organismScrimTextColor: '#ffffff',
  organismScrimTagColor: '#ffffff',
  organismScrimBackgroundColor: '#333333',
  organismScrimBackgroundColorHover: 'lighten',
  organismScrimBorderColor: '#ececec',
  organismScrimLinkColor: '#ececec',
  organismScrimLinkColorHover: '#000088',
  organismContentHeadingSecondaryBorderColor: '#D50032',
  organismContentHeadingPrimaryBorderColor: '#002D72',
  organismSidekickBackgroundColor: '#333333',
  organismJumbotronTitleColor: '#333333',
};

/**
 * A couple of styling updates because some text were illegible in dark mode:
 * - some text went from #333333 -> #ccc
 * - all red #fff -> same as what is in basePalette
 */
const darkPalette = {
  pageContainerBackgroundColor: '#666666',
  pageContainerBorderColor: '#333333',
  headerMastheadBackgroundColor: '#000000',
  headerMastheadTextColor: '#ccc',
  headerNavigationBackgroundColor: '#222222',
  headerNavigationBorderColor: '#222222',
  headerNavigationTextColorHover: '#ffffff',
  headerNavigationTextColor: '#ccc',
  footerTitleColor: '#fff',
  footerTextColor: '#f7f7f7',
  footerBackgroundColor: '#333333',
  footerBorderColor: '#666666',
  footerLinkColor: '#fff',
  footerLinkColorHover: '#fff',
  footerLinkColorActive: '#fff',
  buttonPrimaryBackgroundColor: '#fff',
  buttonPrimaryBackgroundColorHover: 'lighten',
  buttonPrimaryTextColor: '#ccc',
  buttonPrimaryTextColorHover: '#ccc',
  buttonSpotlightBackgroundColor: '#000000',
  buttonSpotlightBackgroundColorHover: 'lighten',
  buttonSpotlightTextColor: '#ccc',
  buttonSpotlightTextColorHover: '#ccc',
  tableHeaderBackgroundColor: '#fff',
  tableRowBackgroundColor: '#333333',
  tableTextColor: '#000000',
  organismSectionTitleColor: '#fff',
  organismTitleColor: '#ffffff',
  organismTextColor: '#f7f7f7',
  organismTagBackgroundColor: '#fff',
  organismTagTextColor: '#ffffff',
  organismBackgroundColor: '#333333',
  organismBorderColor: '#666666',
  organismLinkColor: '#fff',
  organismLinkColorHover: '#fff',
  organismLinkTextDecoration: 'none',
  organismLinkColorActive: '#fff',
  organismScrimTitleColor: '#ccc',
  organismScrimTextColor: '#ccc',
  organismScrimTagColor: '#ccc',
  organismScrimBackgroundColor: '#000000',
  organismScrimBackgroundColorHover: 'lighten',
  organismScrimBorderColor: '#666666',
  organismScrimLinkColor: '#ececec',
  organismScrimLinkColorHover: '#222222',
  organismContentHeadingSecondaryBorderColor: '#fff',
  organismContentHeadingPrimaryBorderColor: '#222222',
  organismSidekickBackgroundColor: '#fff',
  organismJumbotronTitleColor: '#fff',
};

export interface HeaderMenuItems {
  itemId: string;
  text: string;
  properties: {
    link: string;
    customProperties: string;
    icon: string;
  };
}

export const getDefaultHeaderMenu = () =>
  ['news', 'video', 'scores', 'stats', 'standings', 'schedule'].reduce(
    (acc: HeaderMenuItems[], item) => {
      acc.push({
        itemId: item,
        text: item,
        properties: {
          link: `/${item}`,
          customProperties: '',
          icon: item,
        },
      });
      return acc;
    },
    []
  );

export const getMlbHeaderTheme = (theme = 'light') =>
  theme === 'dark' ? darkPalette : basePalette;
